import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
const terms = ['Wystarczy jeden e-mail', 'Żadnych formularzy', 'Pobrane pliki zostają u Ciebie'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-gold-cream py-16 sm:py-24" data-id="element-68" data-mp="222mzz36b0rqw">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-69" data-mp="1x4v2ltmw4dfb">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-4 border-gold bg-white shadow-card" data-id="element-70" data-mp="19dz8gpuyp64w">
          <ShieldCheckIcon className="h-10 w-10 text-gold-dark" aria-hidden="true" data-id="element-71" data-mp="14hhaq9y1u822" />
        </span>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-72" data-mp="1j5va2aw9bedv">Zero ryzyka · 100% ochrony</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-5xl font-extrabold leading-[0.95] text-copy-dark sm:text-7xl" data-id="element-73" data-mp="1ec0u9ijrvjk2">
          10 dni gwarancji
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-copy-dark/80 sm:text-lg" data-id="element-74" data-mp="lon2rzyufg7c">
          Otwórz plan semestru. Przetestuj go na prawdziwych zajęciach. Jeśli Arsenał nie zmieni sposobu, w jaki
          planujesz i uczysz, napisz na{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold-dark underline underline-offset-2 transition-colors duration-150 ease-out hover:text-copy-dark" data-id="element-75" data-mp="yot6q8q1v9hh">
            {SUPPORT_EMAIL}
          </a>{' '}
          w ciągu 10 dni od zakupu, a zwrócimy całe $35. Nie musisz niczego tłumaczyć, a pobrane pliki zostają u
          Ciebie.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-76" data-mp="f12i7gdi0jzx">
          {terms.map(term => <li key={term} className="flex items-center gap-1.5 text-sm font-semibold text-copy-dark" data-id="element-77" data-mp="k1hsfz2hhbdo">
              <CheckIcon className="h-4 w-4 text-btn-shadow" aria-hidden="true" data-id="element-78" data-mp="1qfh6phfzm8tk" />
              {term}
            </li>)}
        </ul>
      </div>
    </section>;
}